import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
/**
 * Impressum/Datenschutz links for the foot of every public page. Lives in
 * components/, not pages/legal/: the build splits pages/ into one chunk per
 * page, and a page importing another page's chunk made them circular.
 */
export function LegalLinks({ className = "" }) {
    return (_jsxs("nav", { className: `flex justify-center gap-4 font-mono text-[11px] uppercase tracking-wide opacity-60 ${className}`, "aria-label": "Rechtliches", children: [_jsx(Link, { to: "/impressum", className: "hover:opacity-100 hover:underline", children: "Impressum" }), _jsx(Link, { to: "/datenschutz", className: "hover:opacity-100 hover:underline", children: "Datenschutz" })] }));
}
